import { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import "bootstrap/dist/css/bootstrap.css";

am4core.useTheme(am4themes_animated);
class SankeyDiagram extends Component {
  state = {
    chart: null,
    dateAxis: null,
    ratioOfMaxToMin: null,
    widthLevel: null,
  };
  componentDidMount() {
    const { data } = this.props;
    this.setState({ ratioOfMaxToMin: Math.max(...data.data.map((item) => item.value)) / (Math.min(...data.data.map((item) => item.value)) !== 0 ? Math.min(...data.data.map((item) => item.value)) : 1) });
    const chart = am4core.create("sankeyDiv", am4charts.SankeyDiagram);
    chart.data = data.data;
    this.setState({ widthLevel: Math.max(...data.data.map((item) => item.level)) });
    chart.dataFields.fromName = "from";
    chart.dataFields.toName = "to";
    chart.dataFields.value = "value";
    chart.paddingRight = 160;
    chart.paddingBottom = 20;
    chart.tooltip.fontSize = 12;
    chart.tooltip.background.fillOpacity = 0.7;
    let linkTemplate = chart.links.template;
    linkTemplate.tooltipText = "{tooltipText}";
    linkTemplate.fillOpacity = 0.2;
    linkTemplate.tooltipPosition = "pointer";
    let hoverState = linkTemplate.states.create("hover");
    hoverState.properties.fillOpacity = 0.5;
    linkTemplate.interactionsEnabled = true;
    linkTemplate.adapter.add("stroke", function (stroke, target) {
      let h = Math.abs(target.linkWidth);
      if (h <= 1) {
        target.strokeOpacity = 0.5;
        target.strokeWidth = 1;
        return target.fill;
      } else {
        target.strokeOpacity = 0;
        return stroke;
      }
    });
    let nodeTemplate = chart.nodes.template;
    nodeTemplate.clickable = false;
    nodeTemplate.nameLabel.label.width = 200;
    nodeTemplate.nameLabel.label.truncate = true;
    let hoverState2 = nodeTemplate.nameLabel.label.states.create("hover");
    hoverState2.properties.wrap = true;
    nodeTemplate.width = 5;
    nodeTemplate.fontSize = 12;
    nodeTemplate.nameLabel.label.fontWeight = "normal";
    nodeTemplate.nameLabel.label.minWidth = 230;
    nodeTemplate.nameLabel.label.maxWidth = 230;
    this.setState(() => ({ chart }));
  }
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  render() {
    return (
      <div className="w-100">
        <div id="sankeyDiv" className="text-capitalise" style={{ width: this.state.widthLevel === 2 ? "100%" : "60%", height: this.state.ratioOfMaxToMin > 10 ? "1000px" : this.state.ratioOfMaxToMin <= 10 && this.state.ratioOfMaxToMin > 5 ? "700px" : "500px" }} />
        {/* {this.state.chart ?
          <AmchartsReact
            chart={this.state.chart}
          />
          : null} */}
      </div>
    );
  }
}

export default SankeyDiagram;
